import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=31431bbe&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"
import style0 from "./TabsComponent.vue?vue&type=style&index=0&id=31431bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31431bbe",
  null
  
)

export default component.exports